module.exports = __webpack_public_path__ + "static/media/ATB.f7ca85eb.png";